import SettingsSection from './SettingsSection';
import { withSubComponents } from '@/utils/react';
import SettingsSectionContent from './SettingsSectionContent';
import SettingsSectionList from './SettingsSectionList';
import SettingsSectionListItem from './SettingsSectionListItem';
import SettingsSectionListAddButton from './SettingsSectionListAddButton';

export default withSubComponents(SettingsSection, {
    Content: SettingsSectionContent,
    List: SettingsSectionList,
    ListItem: SettingsSectionListItem,
    ListItemAddButton: SettingsSectionListAddButton,
});